
































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getGameGiftCode } from "@/req/game";
import qs from "@/components/queSheng.vue";
import VueClipboard from "vue-clipboard2"; // 复制粘贴插件
Vue.use(VueClipboard);

@Component({
  components: { qs },
})
export default class Home extends Vue {
  @Prop({
    type: Object,
    default() {
      return {
        publicity: [],
      };
    },
  })
  public detail;
  public data: any = [];
  public modelShow = false;
  public onCopy(e) {
    this.$Message.success("复制成功！");
  }
  public onError(e) {
    this.$Message.error("复制失败！");
  }
  public mounted() {
    this.getList();
  }
  public async getList() {
    if (!this.$fn.cookies.getToken()) {
      // (this as any).$toast(true);
      this.modelShow = false;
      return false;
    }
    this.data = [];
    const res = await getGameGiftCode({
      token: this.$fn.cookies.getToken(),
      box_game_id: this.$route.params.id.slice(0, -5),
    });
    if (res.code == 200) {
      this.data = res.data;
      this.modelShow = true;
    }
    //  else {
    //   this.data = []
    //   this.modelShow = true
    // }
  }
}
